export default __webpack_public_path__ + "static/media/icon-insights-performance-sauce-revenue.d8e9ab95.svg";